<template>
  <div class="companyInvitationApprovalBox">
    <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
      <Form-item label="姓名：" prop="adminNikeName">
        <Input v-model="formCustom.adminNikeName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="手机号：" prop="adminTelephone">
        <Input v-model="formCustom.adminTelephone" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="审批状态：" prop="approvalStatus">
        <Select v-model="formCustom.approvalStatus" clearable filterable placeholder="请选择" style="width: 200px">
          <Option value="2">待审批</Option>
          <Option value="3">审批通过</Option>
          <Option value="4">审批拒绝</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button type="primary" @click="approvalDialogShow()">批量审批</Button>
    </div>
    <div>
      <Table :columns="companyInvitationApprovalColumns" :data="companyInvitationApprovalTableData" :loading="loading"
             aria-describedby="" aria-hidden="true" border @on-selection-change="selectionChange">
        <template slot="approvalStatus" slot-scope="{ row }">
          <span>{{
              row.approvalStatus === 2 ? '待审批' : row.approvalStatus === 3 ? '审批通过' : row.approvalStatus === 4 ? '审批拒绝' : '其他'
            }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="row.approvalStatus === 2" size="small" type="text" @click="approvalDialogShow(row)">审批
          </Button>
          <Button size="small" type="text" @click="detailDialogShow(row)">详情</Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
    <el-dialog :visible.sync="approvalDialogVisible" title="企业邀请审批" width="30%">
      <Form ref="approvalForm" :label-width="120" :model="formCustom">
        <Form-item label="审批结果：">
          <RadioGroup v-model="approvalStatus" @on-change="changeApprovalStatus">
            <Radio label="3">通过</Radio>
            <Radio label="4">拒绝</Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="审批意见：">
          <Input v-model="approvalIdea" :rows="4" placeholder="请输入审批意见" type="textarea"/>
        </Form-item>
        <Form-item v-if="roleShow" label="关联角色：" prop="roleId">
          <Select v-model="formCustom.roleId" clearable filterable style="width: 240px" @on-change="changeRole">
            <Option v-for="item in roleList" :value="item.roleId">{{ item.roleName }}</Option>
          </Select>
        </Form-item>
        <Form-item>
          <Button class="next" type="primary" @click="approval">提交</Button>
        </Form-item>
      </Form>
    </el-dialog>
    <el-dialog :visible.sync="detailDialogVisible" title="查看企业邀请" width="730px">
      <company-invitation-approval-detail :key="row.companyInvitationId" :row="row"
                                          @detailSuccess="detailSuccess"></company-invitation-approval-detail>
    </el-dialog>
  </div>
</template>

<script>
import permissionList from '@/libs/handlePermission.ts'
import {companyInvitationApproval, companyInvitationApprovalPage} from "@/api/organization";
import companyInvitationApprovalDetail from '@/views/organization/companyInvitationApprovalDetail.vue'
import {roleList} from "@/api/authority";

export default {
  name: 'companyInvitationApproval',
  components: {
    companyInvitationApprovalDetail
  },
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyInvitationIds: '',
      formCustom: {
        adminNikeName: '',
        adminTelephone: '',
        approvalStatus: ''
      },
      companyInvitationApprovalColumns: [
        {type: 'selection', width: 60, align: 'center'},
        {type: 'index', title: '序号', align: 'center'},
        {title: '姓名', key: 'adminNikeName', align: 'center'},
        {title: '手机号', key: 'adminTelephone', align: 'center'},
        {title: '申请时间', key: 'createTime', align: 'center'},
        {title: '审批状态', key: 'approvalStatus', slot: 'approvalStatus', align: 'center'},
        {title: '审批人', key: 'approvalUserName', align: 'center'},
        {title: '审批时间', key: 'approvalTime', align: 'center'},
        {title: '操作', slot: 'action', align: 'center', fixed: 'right'}
      ],
      companyInvitationApprovalTableData: [], // 表格数据
      row: {},
      approvalDialogVisible: false,
      approvalStatus: '',
      approvalIdea: '',
      roleId: '',
      detailDialogVisible: false,
      roleShow: false, // 关联角色disabled
      roleList: [] // 关联角色下拉框
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      companyInvitationApprovalPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res)
      })
      roleList({
        organizationType: 1
      }).then((res) => {
        this.roleList = res.data.data
      })
    },
    selectionChange(rows) {
      this.companyInvitationIds = ''
      if (rows && rows.length > 0) {
        let ids = []
        rows.forEach(row => {
          ids.push(row.companyInvitationId)
        })
        this.companyInvitationIds = ids.join(",")
      }
    },
    // 查询
    handleSearch() {
      const data = {
        ...this.formCustom
      };
      companyInvitationApprovalPage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.companyInvitationApprovalTableData = res.data.data.records
      this.loading = false
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    // 改变页码
    setCurrent(val) {
      const data = {
        ...this.formCustom
      };
      this.loading = true
      this.page = val
      companyInvitationApprovalPage({
        current: val,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      const data = {
        ...this.formCustom
      };
      this.loading = true
      this.pageSize = val
      companyInvitationApprovalPage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    approvalDialogShow(row) {
      if (row?.companyInvitationId) {
        let ids = []
        ids.push(row.companyInvitationId)
        this.companyInvitationIds = ids.join(",")
      }
      if (this.companyInvitationIds === null || this.companyInvitationIds.length === 0) {
        this.$Message.warning('请选择一条记录！')
        return;
      }

      this.approvalDialogVisible = true
    },
    approval() {
      if (this.approvalStatus === '4' && (this.approvalIdea === null || this.approvalIdea === '')) {
        this.$Message.warning('请填写审批意见！')
        return;
      }
      if (this.approvalStatus === '3' && (this.roleId === null || this.roleId === '')) {
        this.$Message.warning('请选择关联角色！')
        return;
      }

      companyInvitationApproval({
        companyInvitationIds: this.companyInvitationIds,
        approvalStatus: this.approvalStatus,
        approvalIdea: this.approvalIdea,
        roleId: this.roleId
      }).then((res) => {
        if (res.data.success === false) {
          this.$Message.error(res.data.msg)
        } else {
          this.$Message.success(res.data.msg)
          this.init()
        }
      })
      this.approvalDialogVisible = false
    },
    detailDialogShow(row) {
      this.row = row
      this.detailDialogVisible = true
    },
    detailSuccess() {
      this.detailDialogVisible = false
    },
    // 获取下拉框审批结果数据
    changeApprovalStatus(val) {
      if (val === '3') {
        this.roleShow = true
      } else if (val === '4') {
        this.roleShow = false
      }
    },
    // 获取下拉框关联角色数据
    changeRole(val) {
      this.roleId = val
    }
  }
}
</script>
<style lang="less">
.next {
  border-radius: 4px;
  background-color: rgba(0, 123, 211, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  height: 50px;
  border-color: #3A62D7;
  width: 80%
}
</style>
